<template>
    <div>
        <div class="table-listings table-sme-report">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                empty-text="No Data"
                v-loading="isTableLoading"
                show-summary
                :summary-method="getSummaries"
            >
                <el-table-column
                    prop="credit_report_id"
                    label="ID"
                    width="90"
                    fixed
                >
                    <template scope="scope">
                        <div>
                            <p class="top-line">{{ scope.row.credit_report_id }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_comp_name"
                    label="Company Name"
                    width="300"
                    :fixed="isFixed"
                >
                    <template scope="scope">
                        <div class="py-2">
                            <p class="top-line">{{ scope.row.credit_report_comp_name }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_comp_reg"
                    label="Company Reg No"
                    min-width="200">
                    <template scope="scope">
                        <p class="top-line">{{ scope.row.credit_report_comp_reg }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_comp_type"
                    label="Company Type"
                    min-width="180">
                    <template scope="scope">
                        <p class="top-line">{{ scope.row.credit_report_comp_type }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_partner_json"
                    label="Company Partners"
                    min-width="240">
                    <template scope="scope">
                        <div v-if="scope.row.credit_report_partner_json.length != 0">
                            <el-tooltip>
                                <div slot="content">
                                    <div v-for="(partner, index) in scope.row.credit_report_partner_json" :key="index" class="p-1 rounded">
                                        <li class=" text-light">{{ partner.partner_name }}: {{ partner.partner_ic }}</li>
                                    </div>
                                </div>
                                <div>
                                    <div v-for="(partner, iter) in scope.row.credit_report_partner_json.slice(0,2)" :key="iter" >
                                        <div>
                                            <li class="top-line">{{ partner.partner_name | shortenText(15) }}</li>
                                        </div>
                                    </div>
                                    <div v-if="scope.row.credit_report_partner_json.length > 2">
                                        <p class="top-line">+ {{ scope.row.credit_report_partner_json.length - 2 }}</p>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_pay_amount"
                    min-width="180"
                    class-name="text-left">
                    <template #header>
                            <div class="text-right">
                                Total Amount
                            </div>
                    </template>
                    <template scope="scope">
                        <p class="top-line">RM {{ scope.row.credit_report_pay_amount | moneyFormatter }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_lg_guarantor"
                    min-width="100"
                    class-name="text-center">
                    <template #header>
                        <div class="text-center w-100">   
                            L.G
                        </div>
                    </template>
                    <template scope="scope">
                        <p class="top-line text-success" v-if="scope.row.credit_report_lg_guarantor"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg></p>
                        <p class="top-line text-danger" v-else><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9"/></svg></p>
                    </template>
                    
                </el-table-column>
                <el-table-column
                    prop="credit_report_ccris"
                    min-width="120"
                    class-name="text-center">
                    <template #header>
                        <div class="text-center w-100">
                            CCRIS SUP
                        </div>
                    </template>
                    <template scope="scope">
                        <p class="top-line text-success" v-if="scope.row.credit_report_ccris"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg></p>
                        <p class="top-line text-danger" v-else><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9"/></svg></p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_ssm"
                    min-width="120"
                    class-name="text-center">
                    <template #header>
                        <div class="text-center w-100">
                            SSM Live
                        </div>
                    </template>
                    <template scope="scope">
                        <p class="top-line text-success" v-if="scope.row.credit_report_ssm"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg></p>
                        <p class="top-line text-danger" v-else><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512m-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9"/></svg></p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="ctos_file"
                    label="CTOS FIle"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line text-primary cursor-pointer" v-if="scope.row.credit_report_html_unsigned_url"><a target="_blank" :href="scope.row.credit_report_html_unsigned_url">VIEW FILE</a></p>
                        <p class="top-line" v-else>-</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_consent_unsigned_url"
                    label="Consent Form"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line text-primary cursor-pointer" @click="$refs.preview_modal.preview(scope.row.credit_report_consent_unsigned_url)" v-if="scope.row.credit_report_consent_unsigned_url">VIEW FILE</p>
                        <p class="top-line" v-else>-</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_ic_front_unsigned_url"
                    label="IC Front"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line text-primary cursor-pointer" @click="$refs.preview_modal.preview(scope.row.credit_report_ic_front_unsigned_url)" v-if="scope.row.credit_report_ic_front_unsigned_url">VIEW FILE</p>
                        <p class="top-line" v-else>-</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_ic_back_unsigned_url"
                    label="IC Back"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line text-primary cursor-pointer" @click="$refs.preview_modal.preview(scope.row.credit_report_ic_back_unsigned_url)" v-if="scope.row.credit_report_ic_back_unsigned_url">VIEW FILE</p>
                        <p class="top-line" v-else>-</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_request_datetime"
                    label="Request Datetime"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line">{{ scope.row.credit_report_request_datetime | dateTimeFormatString }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_response_datetime"
                    label="Ctos Response Datetime"
                    min-width="250">
                    <template scope="scope">
                        <p class="top-line">{{ scope.row.credit_report_response_datetime | dateTimeFormatString }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_status"
                    label="Request Status"
                    min-width="180">
                    <template scope="scope">
                        <p class="top-line badge p-2" :class="{[generateStatusColor(scope.row.credit_report_status)]: true}">
                            {{ scope.row.credit_report_status }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="credit_report_internal_response_code"
                    min-width="180">
                    <template #header>
                        <div class="text-center w-100">
                            Response Code
                        </div>
                    </template>
                    <template scope="scope">
                        <p class="top-line text-center">{{ scope.row.credit_report_internal_response_code }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap mt-5">
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ pagination.from ? pagination.from : 0 }} to {{ pagination.to ? pagination.to : 0 }} of {{ pagination.total ? pagination.total : 0 }} entries
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage"
                    placeholder="Per page" @change="perPageChanged">
                    <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                        :label="item" :value="item">
                    </el-option>
                </el-select>

            </div>
            <base-pagination class="pagination-no-border" :current="pagination.currentPage"
                :per-page="pagination.perPage" :total="pagination.total" v-model="pagination.currentPage" @change="paginationChanged($event)">
            </base-pagination>
        </div>

        <PreviewModal ref="preview_modal"></PreviewModal>

    </div>
</template>

<script>
import { Card, Button, Tag, Select, Option, Input, DatePicker, Table, TableColumn, Tooltip } from 'element-ui'
import {
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'
import PreviewModal from '@/components/Modal/PreviewModal.vue'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { mapState } from 'pinia'

export default {
    components: {
            [Card.name]: Card,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Select.name]: Select,
            [Option.name]: Option,
            [Input.name]: Input,
            [DatePicker.name]: DatePicker,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Tooltip.name]: Tooltip,
            PreviewModal
    },
    data() {
        return {
            isTableLoading: true,
            tableData: [],
            pagination: {
							perPageOptions: [5, 10, 25, 50, 100, 500],
							currentPage: 1,
							perPage: 10,
							total: 0,
							from: null,
							to: null
						},
            isFixed: true,
            dummyData: [
                {
                    id: 2953,
                    comp_name: 'Anggun Terbagus Enterprise',
                    comp_reg_no: 'SA0430286D',
                    comp_type: 'Business',
                    comp_partners: '',
                    total_amount: 25,
                    lg: 0,
                    ccris_sup: 0,
                    ssm_live: 0,
                    ctos_file: '',
                    consent_form: '',
                    ic_front: '',
                    ic_back: '',
                    request_datetime: '',
                    ctos_resp_datetime: '19 Dec 2020 14:04:50',
                    request_status: 'Completed',
                    resp_code: '',
                },
                {
                    id: 2918,
                    comp_name: 'Anggun Terbagus Enterprise',
                    comp_reg_no: 'SA0430286D',
                    comp_type: 'Business',
                    comp_partners: '',
                    total_amount: 25,
                    lg: 0,
                    ccris_sup: 0,
                    ssm_live: 0,
                    ctos_file: '',
                    consent_form: '',
                    ic_front: '',
                    ic_back: '',
                    request_datetime: '',
                    ctos_resp_datetime: '19 Dec 2020 14:04:50',
                    request_status: 'CTOS Unavailable',
                    resp_code: 'Mandatory for Business to be opted for SME Score',
                },
                {
                    id: 2918,
                    comp_name: 'Noriah De Food Sdn. Bhd',
                    comp_reg_no: '1235592T',
                    comp_type: 'Company',
                    comp_partners: '',
                    total_amount: 25,
                    lg: 0,
                    ccris_sup: 0,
                    ssm_live: 0,
                    ctos_file: '',
                    consent_form: '',
                    ic_front: '',
                    ic_back: '',
                    request_datetime: '',
                    ctos_resp_datetime: '19 Dec 2020 14:04:50',
                    request_status: 'Completed',
                    resp_code: '',
                },
            ],
        }
    },
    created() {
        this.getCreditReportsList()
        
    },
    computed: {
        ...mapState(useAuthStore,['auth_user']),
        ...mapState(useConfigStore, ['app_code']),
    },  
    mounted() {
        this.setFixed();
        window.addEventListener('resize', this.setFixed);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setFixed);
    },
    methods: {
        setFixed() {
            this.isFixed = window.innerWidth > 768;
        },
        generateStatusColor(status) {
             return status == 'completed' ? 'badge-success' : 'badge-danger'
        },
        perPageChanged() {
            this.getCreditReportsList()
        },
        paginationChanged(page) {
            this.pagination.currentPage = page
            this.getCreditReportsList()
        },
        async getCreditReportsList(data={}) {
            this.isTableLoading = true
            let queryParams = _gHlp.generateQueryParams({
                paginate:this.pagination.perPage,
                page:this.pagination.currentPage,
                orderBy:{
                    credit_report_id:'desc'
                },
                search:{	
                    "credit_report_id": null,
                    "credit_report_platform": 'CTOS',
                    "credit_report_type":"company",
                    "credit_report_cust_name": null,
                    "credit_report_cust_dob": null,
                    "credit_report_cust_ic": null,
                    "credit_report_pdf_unsigned_url": null,
                    "credit_report_status": data.request_status,
                    "credit_report_comp_name": data.company_name,
                    "credit_report_internal_response_code": null,
                    "credit_report_errors": null,
                    "credit_report_custom_identifier": null,
                    "credit_report_application_code": this.app_code,
                    "credit_report_corporate_id": this.auth_user.account_info.corporate_id,
                    "credit_report_date_type": data.date_type,
                    "credit_report_date_start": data.date_start,
                    "credit_report_date_end": data.date_end,
                }
            })

            const url = `${services.commitment}credit-reports?${queryParams}`
            axios.get(url, {headers: getHeader()})
            .then(res => {
                this.tableData = res.data.data
                this.pagination = _gHlp.setPaginate(res.data.meta)
                this.isTableLoading = false
            }).catch(e => {
				this.isTableLoading = false
                this.errorFunction(e)
            })
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 4) {
                    sums[index] = 'TOTAL'
                }
                if (index === 5) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0)
                        sums[index] = sums[index].toLocaleString(undefined, {minimumFractionDigits: 2});
                        sums[index] = 'RM ' + sums[index]
                    } else {
                        sums[index] = 'N/A';
                    }
                }
            });
            return sums;
        },
    }
}
</script>